<script lang="ts">
    export let value: string = '';
    export let suggestions: string[] = [];
    export let disabled: boolean = false;
    export let style: string = '';
    export let className: string = '';
    export let autofocus: boolean = false;
    export let valid: boolean = true;
    export let placeholder: string = '';
    export const focus: () => void = () => { input?.focus(); }

    let input: HTMLInputElement;
    let filteredSuggestions: string[] = [];
    let selectedSuggestionIndex: number = -1;

    function filterSuggestions() {
        selectedSuggestionIndex = -1;
        let matching: string[] = [];
        if (value && suggestions.length) {
            suggestions.forEach(s => {
                if (s.toLocaleLowerCase().match(new RegExp(value))) {
                    matching.push(s);
                }
            })
        }
        filteredSuggestions = matching;
    }

    function navigateList(e: any) {
        if (e.key === "ArrowDown" && selectedSuggestionIndex <= filteredSuggestions.length-1) {
            selectedSuggestionIndex === filteredSuggestions.length-1 ? selectedSuggestionIndex = 0 : selectedSuggestionIndex += 1
        } else if (e.key === "ArrowUp" && selectedSuggestionIndex >= 0) {
            selectedSuggestionIndex === 0 ? selectedSuggestionIndex = filteredSuggestions.length-1 : selectedSuggestionIndex -= 1
        } else if (e.key === "Enter") {
            setInputValue(filteredSuggestions[selectedSuggestionIndex]);
        } else {
            return;
        }
    }

    function setInputValue(suggestion: string) {
        input.value = suggestion.replace(/<(.)*?>/g, "");
        filteredSuggestions = [];
    }

    function clearSuggestions() {
        filteredSuggestions = [];
    }
</script>

<span class="input-suggest">
    <input class="input-small {className}" type="text" class:invalid-input={!valid}
        bind:this={input}
        bind:value={value}
        disabled={disabled}
        style={style}
        placeholder={placeholder}
        on:keydown={navigateList}
        on:keyup
        on:keypress
        on:change
        on:input={filterSuggestions}
        on:input
        on:blur={clearSuggestions}
        {autofocus}
    />
    {#if filteredSuggestions.length > 0}
        <span class="input-suggest-list">
            <ul>
                {#each filteredSuggestions as suggestion, i}
                    <li class:selected={selectedSuggestionIndex === i} on:click={() => setInputValue(suggestion)}>{@html suggestion}</li>
                {/each}
            </ul>
        </span>
    {/if}
</span>

<style>
    .input-small {
        /*border: 1px solid #ccc;*/
        /*border-radius: 5px;*/
        /*min-width: 188px;*/
        outline: 0;
        font-weight: 500;
        padding: var(--input-small-padding);
        border: var(--input-small-border);
        color: var(--input-small-color);
        border-radius: var(--input-small-border-radius);
    }
    .input-error {
        border-color: var(--automapa-red);
    }
    .input-suggest {
        display: flex;
        flex-direction: column;
    }
    .input-suggest-list {
        position: relative;
    }
    .input-suggest-list ul {
        position: absolute;
        width: 100%;
        border: 1px solid #bbbbbb;
        border-radius: 5px;
        background-color: #ffffff;
        box-shadow: 0px 1px 3px 1px #bbb;
        margin: 0;
        padding: 5px;
        z-index: 10;
    }
    .input-suggest-list ul li {
        list-style: none;
        padding: 6px;
    }
    .input-suggest-list ul li.selected {
        background-color: #ccc;
    }
</style>
